import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableScrollScrollbarFn = /* @__PURE__ */ createRecipe('table-scroll-scrollbar', {}, [])

const tableScrollScrollbarVariantMap = {}

const tableScrollScrollbarVariantKeys = Object.keys(tableScrollScrollbarVariantMap)

export const tableScrollScrollbar = /* @__PURE__ */ Object.assign(memo(tableScrollScrollbarFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableScrollScrollbar',
  __getCompoundVariantCss__: tableScrollScrollbarFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableScrollScrollbarVariantKeys,
  variantMap: tableScrollScrollbarVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableScrollScrollbarVariantKeys)
  },
  getVariantProps: tableScrollScrollbarFn.getVariantProps,
})